module.exports = __webpack_public_path__ + "static/media/ESS_building.e4e441f2.png";